<template>
    <div class="login-template">
        <div class="left-side">
            <div class="top">
                <a href="/" class="logo">
                    <logo></logo>
                </a>
            </div>
            <div class="login-content">
                <div class="content">
                    <h1>{{ $t('reset-password.headline') }}</h1>
                    <form>
                        <div class="material-input">
                            <input id="password" type="password" class="form-control" name="password" v-model="password"
                                   required>
                            <p class="label"><label for="password">
                                {{ $t('reset-password.form.new-password') }}
                            </label></p>
                        </div>
                        <div class="material-input">
                            <input id="password-confirm" type="password" class="form-control"
                                   name="password_confirmation" v-model="password_confirmation" required>
                            <p class="label"><label
                                for="password">{{ $t('reset-password.form.confirm-password') }}</label></p>
                        </div>
                        <div class="button-container">
                            <button type="submit" :disabled="!validateInput" class="purple"
                                    @click.prevent="changePassword">
                                {{ $t('reset-password.button.label') }}
                            </button>
                        </div>
                        <div v-if="showErrors">
                            <ul v-for="error in showErrors">
                                <li>{{ error }}</li>
                            </ul>
                        </div>
                    </form>
                </div>
            </div>
            <div class="bottom">
                <copyright></copyright>
                <span class="seperator">|</span>
                <a target="_blank" href="https://www.rently.dk/terms/">{{ $t('login.terms-conditions') }}</a>
            </div>
        </div>
        <div class="right-side">
            <div class="content">
                <div class="image">
                    <img src="/images/img/login-illustrationv2.png">
                </div>
                <div class="text">
                    <h2>{{ $t('login.teaser.line-one') }}
                        <br>{{ $t('login.teaser.line-two') }}</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {store} from "../../store";

import Logo from '../../components/Logo';
import Copyright from '../../components/Copyright';

export default {
    async beforeRouteEnter(to, from, next) {
        if (JSON.stringify(to.params).length > 2) {
            await store.dispatch('fetchPasswordResetHash', to.params.hash);
            next();
        } else {
            await store.commit('fetchPasswordResetHash', '');
            next();
        }
    },
    data: () => ({
        password: '',
        password_confirmation: '',
    }),
    computed: {
        ...mapGetters([
            'getPasswordResetHash'
        ]),
        validateInput() {
            return this.password && (this.password === this.password_confirmation);
        },
    },
    components: {
        Logo,
        Copyright
    },
    methods: {
        changePassword() {

            axios({
                method: 'POST',
                url: this.$root.apiUrl + 'api/password/change',
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    token: this.getPasswordResetHash
                }
            }).then(() => {
                this.$swal('Password successfully changed!', '', 'success');
            });

            this.$router.push('/login');

        }
    }
}
</script>

<style scoped>

</style>
